import appmixer from '../../../plugins/appmixer';
import UserRequests from '../../../utils/requests/user';

async function baseAuthenticate(commit, dispatch, state, getters, token, refToken, tokenGetter, {
    errorPermissions,
    errorForbidden,
    errorOther
}) {
    commit('setLoading', true);
    try {
        let accessToken = token;
        let refreshToken = refToken;
        if (!accessToken) {
            const data = await tokenGetter();
            if (data.hasOwnProperty('refreshToken') && data.refreshToken) {
                refreshToken = data.refreshToken;
                await appmixer.setRefreshToken(data.refreshToken);
            }
            appmixer.set('accessToken', data.token);
            accessToken = data.token;
        } else {
            appmixer.set('accessToken', accessToken);
        }

        await dispatch('queryUser');
        if (!state.user.scope.includes('admin')) {
            commit('unsetAccessToken');
            commit('unsetRefreshToken');
            commit('setUser', {});
            commit('setError', errorPermissions);
            return;
        }
        commit('setAccessToken', accessToken);
        commit('setRefreshToken', refreshToken);
        commit('setError', null);
    } catch (error) {
        if ((error.response || {}).status === 403) {
            commit('setError', errorForbidden);
        } else {
            commit('setError', errorOther);
        }
    }
    commit('setLoading', false);
}

export default {
    async authenticate({ commit, dispatch, state, getters }, { username, password, token, refreshToken }) {
        await baseAuthenticate(commit, dispatch, state, getters, token, refreshToken, async () => {
            return UserRequests.authenticateUser(username, password);
        }, {
            errorPermissions: 'You are not allowed to login into the backoffice.',
            errorForbidden: 'Email and/or password does not match our records.\nPlease try again.',
            errorOther: 'Something went wrong signing-in.\nPlease try again later.'
        });
    },

    async authenticateWithSSO({ commit, dispatch, state, getters }, { redirectUri, code, token, refreshToken }) {
        await baseAuthenticate(commit, dispatch, state, getters, token, refreshToken, async () => {
            return UserRequests.authenticateSSOUser(redirectUri, code);
        }, {
            errorPermissions: 'You are not allowed to login into the backoffice.',
            errorForbidden: 'Error while exchanging credentials with the IDP.\nPlease try again.',
            errorOther: 'Something went wrong signing-in.\nPlease try again later.'
        });
    },

    async loadRefreshToken({ commit, dispatch, state, getters }, { refreshToken }) {
        await appmixer.setRefreshToken(refreshToken);
        commit('setRefreshToken', refreshToken);
    },

    async queryUser({ commit }) {
        const data = await UserRequests.queryAuthUser();
        commit('setUser', data);
    }
};
